<template>
	<article class="search-default-text">
		<managing-section :is-table="true">
			<table class="table-main">
				<thead>
					<tr>
						<th v-for="item in thList" :key="item">{{ item }}</th>
					</tr>
				</thead>
				<tbody v-if="tableData && tableData.length">
					<tr
						v-for="item in tableData"
						:key="item.idSearchRecommend"
						:style="{
							fontWeight: item.isDisplay ? 'bold' : 'normal',
							backgroundColor:
								item.recommendType === 'main_placeholder' ||
								item.recommendType === 'review_placeholder' ||
								item.recommendType === 'common_placeholder'
									? 'darkseagreen'
									: '',
						}"
					>
						<td>{{ item.idSearchRecommend }}</td>
						<td>{{ item.recommendText }}</td>
						<td>{{ item.recommendType }}</td>
						<td>{{ item.isDisplay ? '활성' : '비활성' }}</td>
						<td>{{ parsingDate(item.startDate, 'date') }}</td>
						<td>{{ parsingDate(item.endDate, 'date') }}</td>
						<td>{{ item.nickName }}</td>
						<td>{{ parsingDate(item.createDate) }}</td>
						<td>
							<router-link
								class="btn"
								:to="`/manage/add-search-default-text?idSearchRecommend=${item.idSearchRecommend}`"
								>수정</router-link
							>
						</td>
					</tr>
				</tbody>
				<tbody v-else-if="tableData">
					<tr>
						<td :colspan="thList.length">목록이 없습니다.</td>
					</tr>
				</tbody>
			</table>
			<pagination-box
				slot="pagination"
				@to="getTableData($event.offset)"
				:total-item="totalItem"
				:offset="offset"
				:limit="20"
				:page-leng-per-one="10"
			/>
		</managing-section>
	</article>
</template>

<script>
	import moment from 'moment';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import PaginationBox from '@/components/PaginationBox.vue';

	export default {
		name: 'SearchDefaultText',
		components: { ManagingSection, PaginationBox },
		data() {
			return {
				thList: [
					'번호',
					'텍스트',
					'검색창',
					'활성',
					'시작일',
					'마감일',
					'등록자',
					'등록일',
					'수정',
				],
				tableData: null,
				totalItem: 0,
				offset: 0,
			};
		},
		mounted() {
			this.getTableData();
		},
		methods: {
			parsingDate(date, type) {
				return date
					? moment(date, 'YYYYMMDDHHmmss').format(
							type === 'date'
								? 'YYYY-MM-DD'
								: 'YYYY-MM-DD HH:mm:ss'
						)
					: '-';
			},
			async getTableData(offset = 0) {
				try {
					this.offset = offset;
					const params = { offset, limit: 20 };
					const { data } = await this.$axiosAdmin2.get(
						'/api/operation/searchRecommends',
						{ params }
					);
					this.tableData = data.content;
					this.totalItem = data.total;
				} catch (err) {
					console.error(err);
					alert(
						'목록을 불러오는데 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
		},
	};
</script>
